import React from 'react';
import { socialShareOptionsList } from '../../assets/data/navigationlinks.json';

const SocialShareOptions = (props) => {
  const { postURL } = props;
  React.useEffect(() => {
    window.onload = () => {
      const twitterScript = document.createElement('script');
      twitterScript.src = 'https://platform.twitter.com/widgets.js';
      document.getElementsByClassName('twitter-embed')[0].appendChild(twitterScript);

      const facebookScript = document.createElement('script');
      facebookScript.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v10.0&appId=132976897257455&autoLogAppEvents=1';
      facebookScript.async = true;
      facebookScript.crossOrigin = 'anonymous';
      facebookScript.nonce = '7EBPBqL1';
      document.body.appendChild(facebookScript);
    };
  }, []);
  const FacebookSocialButton = () => {
    return (
      <div className="" data-href="https://developers.facebook.com/docs/plugins/" data-layout="button_count" data-size="small">
        <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postURL)}`} className="fb-xfbml-parse-ignore">
          <i className="icon-facebook" />
        </a>
      </div>
    );
  };
  const TwitterSocialButton = () => {
    return (
      <section className="twitterContainer">
        <div className="twitter-embed">
          <a
            target="_blank"
            className=""
            href={`https://twitter.com/intent/tweet?text=Hello%20world%20I'm%20testing%20tweet:%20\n${encodeURIComponent(postURL)}`}
            data-size="large"
          >
            <i className="icon-twitter" />
          </a>
        </div>
      </section>
    );
  };

  const getSocialButton = (platform) => {
    if (platform === 'facebook') {
      return <FacebookSocialButton />;
    }
    if (platform === 'twitter') {
      return <TwitterSocialButton />;
    }
    return '';
  };
  const SocialShareIcon = ({ name, link }) => {
    return <li>{getSocialButton(name)}</li>;
  };
  return (
    <div className="social-share-options-wrapper">
      <div className="social-share-icons-group">
        <h6>Share:</h6>
        <ul className="social-share-icons">
          {socialShareOptionsList.map((nav) => (
            <SocialShareIcon key={nav.name} name={nav.name} link={nav.slug} title={nav.text} icon={nav.icon} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SocialShareOptions;
